<div class="form-control-checkbox no-select" *ngIf="!row?.expanded">
  <label class="m-0 d-flex align-items-center">
    <input #input type="checkbox" [(ngModel)]="row.checked" (change)="onChange($event)" *ngIf="row" />
    <input #input type="checkbox" (change)="checkAll($event)" *ngIf="!row" />
    <span [ngClass]="{ 'mb-2 mt-1': !row }"></span>
  </label>
</div>
